function ReportSignalAssignment() {
    /// <summary>
    /// This object provides js functions for the Widget.Membership.Assigment.* <br/>
    /// <br/>
    /// Author: MWI<br />
    /// Date: 11.04.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 11.5.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// * - includes special functions for handling the extra items          *<br />
    /// **********************************************************************<br />
    /// </summary>
  
}

ReportSignalAssignment.prototype = new window.MSAssignment();

ReportSignalAssignment.prototype.loadItems = function (id) {
    /// <summary>
    /// Overload of the parent fucntion to load the items
    /// </summary>
    var me = this;
    
    try {

    //    me.parameter = "";
    //    me.signalParameter = "";
    //me.assID = -1;
    window.MSAssignment.prototype.loadItems.call(me, id);
    //me.visual.find(".connect").off("dblclick", ".vc-list-item");

    } catch (ex) {
        me.writeError('loadItems', ex);
    }
};


//ReportSignalAssignment.prototype.manualUpdate = function(obj) {
//    var me = this;
//    try {

//        console.info(obj);
//        //window.MSAssignment.prototype.initSortable.call(me);
//          //   me.visual.find(".connect").off("dblclick", ".vc-list-item");

//    } catch (ex) {
//        me.writeError('manualUpdate', ex);

//    }
//};

ReportSignalAssignment.prototype.manualSorting = function (obj) {
    /// <summary>
    /// This function resorts the assigned signal list
    /// </summary>
    var me = this;

    try {
      
        if (obj.target.id === "lstTarget") {

            var lst = [];
            $.each(me.visual.find("#lstTarget .vc-list-item"), function () {
                lst.push($(this).data("id"));
            })


            var param = { 'type': 3, 'LoggerId': me.blid, 'assID': me.assID, 'sorting': lst };


            window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, me.parameter, '', me.deviceType, me.langid, JSON.stringify(param),
                function (result) {
                    if (result !== true) {
                        me.showMessage(me.resources.err_saveData, true);
                        return false;
                    }
                    if (me.VCMQ_update_message.length > 0) {
                        _VCMQ.produce(me.visual, me.vcgid, me.VCMQ_update_message, '');
                    }

                    return true;
                });
        };
        return true;
    } catch (ex) {
        me.writeError('manualUpdate', ex);
        return false;
    }

};


//MSAssignmentReport2Logger.prototype.initSortable = function() {
//    var me = this;
//    try {
//          window.MSAssignment.prototype.initSortable.call(me);
//             me.visual.find(".connect").off("dblclick", ".vc-list-item");

//    } catch (ex) {
//               me.writeError('MSAssignmentReport2Logger.initSortable', ex);

//    }
//};

//MSAssignmentReport2Logger.prototype.addspecificClickHandler = function () {
//    /// <summary>
//    /// This function inits the assigment specific click handler if implemented
//    /// </summary>
//    ///<param name='row'> a row object to add the item </param>
//    var me = this;
//    try {
//        if (me.error) { return false; }
//        //_VCMQ.addConsumer(me.vcgid);
//        //_VCMQ.consume(me.visual, me.vcgid, function(event) {me.doEvent(event)});
//        me.visual.find("#lstTarget").off("click").on("click", "  .vc-list-item", function (event) {

//            alert();
//            //me.clickRemoveArrow(event, this);
//        });
//        //me.visual.find("#lstSource").off("click").on("click", " .vc-list-item", function (event) {me.clickAddArrow(event, this);});

//    } catch (ex) {
//        me.writeError('MSAssignmentReport2Logger.addspecificClickHandler', ex);
//        return false;
//    }
//    return true;
//};



